import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import R from 'ramda';

import Box from 'react-bulma-companion/lib/Box';
import Section from 'react-bulma-companion/lib/Section';
import Container from 'react-bulma-companion/lib/Container';
import Button from 'react-bulma-companion/lib/Button';

import Title from 'react-bulma-companion/lib/Title';

import SurveyNav from '_organisms/SurveyNav';
import SurveyBody from '_organisms/SurveyBody';
import ProgressCircle from '_organisms/ProgressCircle';
import ProgressChart from '_organisms/ProgressChart';

import { formatTime } from '_utils/functions';

import { calculateProgress, filterVisibleRoutes } from '_utils/survey';

export default function SurveySection({ survey_id, survey_options, survey_meta, uri, title, body, forward, backward, index, final, error, saved }) {
  return (
    <Section>
      <Container>
        {survey_options.step_counter === true && <ProgressChart survey_meta={survey_meta} title={title} progress={calculateProgress(index, survey_meta["length"])}/>}
        <Box className="survey-box">
            <Title size="1" className="section-title">{`${title.section} - ${title.name}`}</Title>
            <SurveyNav uri={uri} backward={backward} back={index > 0}/>
            
            <SurveyBody survey_id={survey_id} title={body.title} components={body.components} sub_info={body.sub_info} />
            
            <Button className="next-btn" onClick={forward}>
              {final ? 'Submit' : 'Next'}
            </Button>
            {error && <p className="err">{body.error_messages[error] == "" ?  "Please enter an answer." : body.error_messages[error]}</p>}
        </Box>
        {survey_options.progress_bar == 'circle' && <ProgressCircle progress={calculateProgress(index, survey_meta["length"])} timeEstimate={`${formatTime(((survey_meta["length"] - index) * 5))}` /*** TODO: use real time estimate ***/} saved={saved}/>}
      </Container>
    </Section>
  );
}